








import { Component, Vue } from 'vue-property-decorator'
import TedsLauncherLayout from './components/TedsLauncherLayout/TedsLauncherLayout.vue'
import TedsLauncherNotifications from './app/v1/components/TedsLauncherNotifications/TedsLauncherNotifications.vue'

@Component({
  components: {
    TedsLauncherLayout,
    TedsLauncherNotifications,
  },
})
export default class App extends Vue {}
